import { Search } from 'lucide-react';
import { Field, Select, Input } from './ui';

export default function FilterBar({ months, month, onMonth, search, onSearch, label = 'Period' }) {
  return (
    <div className="flex flex-wrap gap-4 items-end mb-6">
      {months && (
        <Field label={label}>
          <Select value={month || ''} onChange={(e) => onMonth(e.target.value)}>
            {months.map((m) => (
              <option key={m.period_month} value={m.period_month}>{m.period_month}</option>
            ))}
          </Select>
        </Field>
      )}
      {onSearch !== undefined && (
        <Field label="Search" className="flex-1 min-w-48">
          <div className="relative">
            <Search
              className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
              strokeWidth={1.75}
            />
            <Input
              type="text"
              placeholder="Project name or client"
              value={search || ''}
              onChange={(e) => onSearch(e.target.value)}
              className="pl-9 w-full"
            />
          </div>
        </Field>
      )}
    </div>
  );
}
